



























































































































































































































































































































































import {Getter, Action} from "vuex-class";
import Component from "vue-class-component";
import {
  SelectWings,
  ToggleWings,
  DatePickerWings,
  FastDateDetailWings,
  NumberWings,
  NewNumberWings,
  InputWings
} from 'wings-ui-components';
import {Prop, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {CdpDetailFilterParams} from "@/store/cdp/statistic/types";
import {mergeData} from "@/utils/data-helper";

@Component({
  components: {
    NewNumberWings,
    NumberWings,
    SelectWings,
    ToggleWings,
    DatePickerWings,
    FastDateDetailWings,
    InputWings
  },
  filters: {dateFilter}
})
export default class CdpDetailFilter extends BaseFilter<CdpDetailFilterParams> {
  @Prop({ required: true }) activeFilter!: string;

  @PropSync('filterClone') propFilterClone!: any;
  @PropSync('runFilter') propRunFilter!: any;

  @Getter("cdpStatusList") statusList: any;
  @Getter("clientAttributes") clientAttributesList: any;
  @Getter("eventAttributes") eventAttributesList: any;
  @Getter("messageTypes") messageTypesList: any;

  @Action("getCdpStatisticDetail") actionGetStatisticDetail: any;
  @Action("exportCdpStatisticDetail") actionExportStatisticDetail: any;
  @Action("getClientAttributes") actionGetClientAttributes: any;
  @Action("getEventAttributes") actionGetEventAttributes: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): CdpDetailFilterParams {
    return new CdpDetailFilterParams(beginningOfCurrentDay(),currentDateEnd());
  }

  params = {transport: MsgTransports.CDP};
  partnersList = []
  accountsList: any = []
  partnerUsersList: any = []
  serviceProvidersList:  any = []
  client_attribute: string[] = []
  event_attribute: string[] = []

  filterKeys: object = {
    "broker_account_login" : "account",
    "partner_user_login": "partner_login",
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts(filter);
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async created() {
    try {
      this.actionGetClientAttributes();
      this.actionGetEventAttributes();
      this.actionGetMessageTypes(this.params);
      this.scroll();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.partner_user_login) this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.partner_user_login});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const finalFilter = {
        ...this.filter,
        ext_client_profile_data: mergeData(this.filter.ext_client_profile_data),
        ext_event_profile_data: mergeData(this.filter.ext_event_profile_data)
      };
      const resp = await this.actionGetStatisticDetail(finalFilter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async doActionExport(filter: CdpDetailFilterParams): Promise<any> {
    return await this.actionExportStatisticDetail(filter);
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: CdpDetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }

  private updateProfileData(ids: string[], data: Array<{ [key: string]: string }> = []) {
    const newData: Array<{ [key: string]: string }> = [];
    ids.forEach((key) => {
      const existingEntry = data?.find((item) => key in item);
      newData.push(existingEntry || { [key]: "" });
    });

    return newData;
  }

  @Watch("client_attribute", { deep: true })
  onClientProfileChange(newIds: string[]) {
    this.filter.ext_client_profile_data = this.updateProfileData(newIds, this.filter.ext_client_profile_data || []);
  }

  @Watch("event_attribute", { deep: true })
  onEventProfileChange(newIds: string[]) {
    this.filter.ext_event_profile_data = this.updateProfileData(newIds, this.filter.ext_event_profile_data || []);
  }
}
